<template>
    <div class="msg">
        <div class="avatar" v-if="avatar"><img :src="avatar" /></div>
        <div class="clear" style="height: 20px" ></div>
        <div class="item" v-for="( param, key ) in params" :class="[param.type, param.style]" :key="key">
            <Phone class="value" v-if="param.type == 'phone'" :phone="param.value"></Phone>
            <Email class="value" v-else-if="param.type == 'email'" :email="param.value"></Email>
            <div class="value" v-else><div class="label" v-if="param.label">{{param.label | i18n}}:</div>{{ formatParam( param ) }}</div>
        </div>
    </div>
</template>

<script>
    import Phone from '@/components/ui/labels/Phone'
    import Email from '@/components/ui/labels/Email'
    import store from '@/store'

    import i18n from '@/i18n'

    export default {
        props: { params: Array, actions: Array, avatar: String },
        components: { Phone, Email },
        data() {
            return {
            }
        },
        methods: {
            formatParam( param ){
                switch( param.type ){
                    case 'string': return i18n.t( param.value );
                    case 'role': return store.getters[ 'persons/getContactTypeById' ]( param.value ).name;
                    case 'email': return param.value;
                    case 'phone': return "<v-icon size='18px'>phone</v-icon>" + param.value;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .avatar {
        width: 100%;
        height: 75px;
        opacity: 0.5;
        text-align: center;

        img {
            height: 100%;
            width: auto;
        }
    }

    .item {
        text-align: center;
        margin: 10px auto;
        width: fit-content;

        &.strong .value {
            font-weight: bold;
            font-size: 20px;
        }

        &.role {
            border-radius: 15px;
            padding: 3px 15px;
            font-weight: lighter;
            margin: 0 auto;
            margin-bottom: 25px;
            
            &.r1 {
                background-color: $bg-role-1;
                color: $co-role-1;
            }
            &.r2 {
                background-color: $bg-role-2;
                color: $co-role-2;
            }
            &.r5 {
                background-color: $bg-role-5;
                color: $co-role-5;
            }
            &.r6 {
                background-color: $bg-role-6;
                color: $co-role-6;
            }
            &.r107 {
                background-color: $bg-role-107;
                color: $co-role-107;
            }
            &.r108 {
                background-color: $bg-role-108;
                color: $co-role-108;
            }
            &.r109 {
                background-color: $bg-role-109;
                color: $co-role-109;
            }
            &.r110 {
                background-color: $bg-role-110;
                color: $co-role-110;
            }
            &.r111 {
                background-color: $bg-role-111;
                color: $co-role-111;
            }

            & .value {
                font-size: 12px;
                text-transform: uppercase;
                color: #fff;
            }
        }

        .label {
            font-weight: lighter;
            font-size: 14px;
            margin-right: 10px;
            display: inline;
        }
    }
</style>